import { actionNames } from './actions'

const initialState = {
  liveData: null,
  liveId: null,
  liveToken: null,
  webinarTimeEpoch: 0,
  criticalError: null,
  localParticipantName: null,
  isMobileDevice: false,
  isWebinarTimeInThePast: false,
  hasBeenBroadcasting: false,
  countdownEnabled: false,
  waitingRoomType: 'simple',
  afterWebinarRoomType: 'simple',
  isWebinarOver: false,
}

const getRoomType = (isWebinarOver, data) => {
  if (isWebinarOver) {
    return data.after_webinar_photo_type || 'simple'
  }

  return data.before_webinar_photo_type || 'simple'
}

const mainReducer = (state = initialState, action = { type: '' }) => {
  switch (action.type) {
    case actionNames.INIT_AUDIENCE_ROOM: {
      return {
        ...state,
        liveId: action.liveId,
        liveToken: action.liveToken,
        isMobileDevice: action.isMobileDevice,
        isWebinarOver: action.showThankYou,
      }
    }
    case actionNames.FETCH_LIVE_DATA_SUCCESS: {
      const webinarTimeEpoch = parseInt(action.data.live_date_epoch, 10)
      const isWebinarOver =
        state.isWebinarOver ||
        (action.data.broadcasting_p === 0 &&
          action.data.live_status === 'previous')

      return {
        ...state,
        liveData: action.data,
        webinarTimeEpoch,
        isWebinarTimeInThePast: webinarTimeEpoch * 1000 < Date.now(),
        hasBeenBroadcasting:
          state.hasBeenBroadcasting || action.data.broadcasting_p === 1,
        countdownEnabled: action.data.before_webinar_countdown_p === 1,
        isWebinarOver,
        waitingRoomType: getRoomType(isWebinarOver, action.data),
      }
    }
    case actionNames.LIVE_STATUS_POLL_SUCCESS: {
      const isLiveBroadcasting =
        action.liveData.broadcasting_p === true ||
        action.liveData.broadcasting_p === 1
      const isWebinarOver =
        state.isWebinarOver ||
        (!isLiveBroadcasting && action.liveData.live_status === 'previous')

      return {
        ...state,
        hasBeenBroadcasting: state.hasBeenBroadcasting || isLiveBroadcasting,
        isWebinarOver,
        waitingRoomType: getRoomType(isWebinarOver, state.liveData),
      }
    }
    case actionNames.LIVE_EVENT_NOT_FOUND: {
      return {
        ...state,
        criticalError: action.error,
      }
    }
    case actionNames.LIVE_COUNTDOWN_ZERO: {
      return {
        ...state,
        isWebinarTimeInThePast: true,
      }
    }
    default:
      return state
  }
}

// eslint-disable-next-line import-x/no-default-export
export default mainReducer
